module.exports = __webpack_public_path__ + "img/Clientes.b5eb5b8e.svg";